import React from 'react'
import { OfflineLiveViewProps } from '../OfflineLiveView'
import GuiLiveView from './GuiLiveView'

interface OfflineGuiLiveViewProps extends OfflineLiveViewProps {
  storageId?: string
}

const OfflineGuiLiveView: React.FC<OfflineGuiLiveViewProps> = ({ storageId, wallboxes, consumers, producers, offlineIcon, shallowLiveView }) => {
  return (
    <GuiLiveView
      storageId={storageId}
      batteryHomePower={0}
      homeBatteryPower={0}
      homeWallboxPower={0}
      wallboxes={wallboxes}
      consumers={consumers}
      producers={producers}
      homeNetworkPower={0}
      networkHomePower={0}
      pvHomePower={0}
      homeConsumerPower={0}
      consumption={0}
      trackerHomePower={0}
      liveData={undefined}
      offlineIcon={offlineIcon}
      shallowLiveView={shallowLiveView}
    />
  )
}

export default OfflineGuiLiveView
